/* global MI, AbstractSymbol */

/**
 * @constructor
 * @returns {SpinReel}
 */
export function SpinReel() {

    /** @type {number} */
    this.id;

    /** @type {GameConfig} */
    this._gameConfig;

    /** @type {SymbolsManager} */
    this._symbolsManager;

    /** @type {Array<AbstractSymbol>} */
    this._symbols = []; //array of actual reel symbols (objects) //3lines => 5 symbols

    /** @type {Array<AbstractSymbol>} */
    this._spinSymbols = []; //array of all reel symbols (objects)

    /** @type {Array<AbstractSymbol>} */
    this._resSymbols = []; //array of displyed symbols (3 lines -> 3 symbols)

    /** @type {Array<AbstractSymbol>} */
    this._tmpSymbols = []; //copy of reelsSymbols

    /** @type {Array<AbstractSymbol>} */
    this._failSymbols = [];

    this._allMatrix = []; //server_config.logic.reels
    this._reelMatrix = []; //server_config.matrix.reelMatrix;
    this._failMatrix = []; //server_config.logic.failResult

    this.symbolPosition = 0;

    this.shiftY = 0;

    this._symbolsScale = 1;

    this.forceStopping = false;
}

/**
 * @returns {Array<MadnesObject>}
 */
SpinReel.prototype.getSymbols = function() {
    return this._symbols;
};

/**
 * @param {number} id
 * @param {GameConfig} gameCfg
 * @param {SymbolsManager} symbolsManager
 */
SpinReel.prototype.init = function(id, gameCfg, symbolsManager) {
    this.id = id;
    this._gameConfig = gameCfg;
    this._symbolsManager = symbolsManager;
};

SpinReel.prototype.setAllMatrix = function(symbolsNum) {
    this._allMatrix = symbolsNum; //.slice(0, 1);
};

SpinReel.prototype.getAllMatrix = function() {
    return this._allMatrix;
};

SpinReel.prototype.setReelMatrix = function(matrix) {
    this._reelMatrix = matrix;
};

SpinReel.prototype.getReelMatrix = function() {
    return this._reelMatrix;
};

SpinReel.prototype.setFailMatrix = function(matrix) {
    this._failMatrix = matrix;
};

SpinReel.prototype.getFailMatrix = function() {
    return this._failMatrix;
};

SpinReel.prototype.getFailSymbols = function() {
    return this._failSymbols;
};

/** @returns {Array<AbstractSymbol>} */
SpinReel.prototype.getResSymbols = function() {
    return this._resSymbols;
};

SpinReel.prototype.setSymbolPosition = function(pos) {
    this.symbolPosition = pos ? pos : 0;
};

/** @returns {Array<AbstractSymbol>} */
SpinReel.prototype.getSpinSymbols = function() {
    return this._spinSymbols;
};

/** @returns {Array<AbstractSymbol>} */
SpinReel.prototype.getTmpSymbols = function() {
    return this._tmpSymbols;
};

//SpinReel.prototype.destroy = function() {
//
//	for(var i = 0; i < this._spinSymbols.length; i++) {
//		this._spinSymbols[i].destroy();
//	}
//	this._spinSymbols.length = 0;
//
//	for(var i = 0; i < this._resSymbols.length; i++) {
//		this._resSymbols[i].destroy();
//	}
//	this._resSymbols.length = 0;
//
//	for(var i = 0; i < this._failSymbols.length; i++) {
//		this._failSymbols[i].destroy();
//	}
//	this._failSymbols.length = 0;
//
//	for(var i = 0; i < this._symbols.length; i++) {
//		this._symbols[i].destroy();
//	}
//	this._symbols.length = 0;
//
//	this._allMatrix.length = 0;
//	this._reelMatrix.length = 0;
//	this._failMatrix.length = 0;
//};